document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", async function () {
    setTimeout(syncLinkedSupplements, 800);
  });

  async function syncLinkedSupplements() {
    try {
      const cartResponse = await fetch("/cart.js");
      const cart = await cartResponse.json();

      const productUIDs = new Set();

      cart.items.forEach(function (item) {
        const props = item.properties || {};

        if (props["_UID"] && props["_Supplément broderie"] !== "true") {
          productUIDs.add(props["_UID"]);
        }
      });

      for (const item of cart.items) {
        const props = item.properties || {};

        if (
          props["_Supplément broderie"] === "true" &&
          props["_UID"] &&
          !productUIDs.has(props["_UID"])
        ) {
          await fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              id: item.key,
              quantity: 0
            })
          });

          window.location.reload();
          return;
        }
      }
    } catch (error) {
      console.error("Erreur suppression supplément lié :", error);
    }
  }
});